import React, { useEffect, useState } from 'react';
import { subscribeSupabaseStatus } from '@/lib/supabase';

const bannerStyle: React.CSSProperties = {
  width: '100%',
  background: '#ffefc1',
  color: '#7a5c00',
  padding: '12px',
  textAlign: 'center',
  fontWeight: 600,
  fontSize: '1rem',
  borderBottom: '2px solid #ffe082',
  zIndex: 9999,
  position: 'fixed',
  top: 0,
  left: 0
};

export default function SupabaseStatusBanner() {
  const [status, setStatus] = useState<'ok' | 'error'>('ok');

  useEffect(() => {
    const unsubscribe = subscribeSupabaseStatus(setStatus);
    return unsubscribe;
  }, []);

  if (status === 'ok') return null;

  return (
    <div className="fixed left-0 right-0 top-24 z-50 flex justify-center px-4">
      <div className="bg-yellow-100 border border-yellow-400 text-yellow-700 px-4 py-3 rounded-lg shadow-lg max-w-lg w-full">
        <div className="flex items-center">
          <div className="py-1">
            <svg className="fill-current h-6 w-6 text-yellow-500 mr-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
              <path d="M2.93 17.07A10 10 0 1 1 17.07 2.93 10 10 0 0 1 2.93 17.07zm12.73-1.41A8 8 0 1 0 4.34 4.34a8 8 0 0 0 11.32 11.32zM9 11V9h2v6H9v-4zm0-6h2v2H9V5z"/>
            </svg>
          </div>
          <div>
            <p className="font-bold">Problemas de conexão</p>
            <p className="text-sm">Estamos com dificuldades para acessar nossos servidores. Por favor, tente novamente em alguns instantes.</p>
          </div>
        </div>
      </div>
    </div>
  );
} 